import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ErrorService } from '@app/common/services/error.service';
import { PlexEnvironment } from '@app/env';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CreateProjectScheduleResult } from '../../models/create-project-schedule-result';

@Injectable({
  providedIn: 'root'
})
export class CreateProjectScheduleService {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);
  public environment = inject(PlexEnvironment);

  private baseUrl: string;

  constructor() {
    this.baseUrl = this.environment.apiUrl;
  }

  createSchedule(projectId: number): Observable<CreateProjectScheduleResult> {
    const queryString = `${this.baseUrl}ProjectsCustom/CreateProjectSchedule`;
    const body = { projectId: projectId };

    return this.http.post(queryString, body).pipe(
      map((response: CreateProjectScheduleResult) => response),
      catchError(error => this.handleErrorObservable(error, 'Error Creating Schedule')),);
  }

  private handleErrorObservable(error: object | any, message: string) {
    this.errorService.error(message, error);
    return throwError(error.message || error);
  }
}